import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ e("path", { d: "M3.75 6.616a.75.75 0 0 0-1.5 0v14.18c0 .966.784 1.75 1.75 1.75h16a1.75 1.75 0 0 0 1.75-1.75V6.615a.75.75 0 0 0-1.5 0v14.18a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V6.615Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12 16.473a3.103 3.103 0 0 0 3.103-3.104c0-.141-.073-.54-.317-1.24a27.151 27.151 0 0 0-.927-2.25A74.506 74.506 0 0 0 12 6.136a74.593 74.593 0 0 0-1.859 3.741c-.376.825-.7 1.6-.927 2.25-.244.702-.317 1.1-.317 1.241A3.103 3.103 0 0 0 12 16.473Zm0 1.5a4.603 4.603 0 0 0 4.603-4.604c0-1.658-2.426-6.37-3.756-8.828a.958.958 0 0 0-1.695 0C9.822 7 7.396 11.711 7.396 13.37A4.603 4.603 0 0 0 12 17.973Z",
  "clip-rule": "evenodd"
}, null, -1), l = [
  c,
  a
];
function d(r, s) {
  return t(), o("svg", n, [...l]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
